
<mat-card class="content-card">
  <div class="header" fxLayout="row wrap" fxLayoutAlign="space-between center" fxLayoutGap="10px">
    <div fxLayout="column">
      <button mat-raised-button color="basic" (click)="returnBack()" style="margin-right: 20px;">Back</button>
    </div>
    <div fxLayout="column">
      <div>
        <div fxLayout="row wrap" fxLayoutGap="8px" *ngIf="table" fxLayoutAlign="end center">

          <mat-form-field class="brand-filter-field"  *ngIf="!currentUserIsPartner()">
            <mat-select placeholder="Brand filters" [(ngModel)]="table.filters.companiesFilter" multiple>
              <mat-option *ngFor="let company of companies" [value]="company.id">{{company.name}}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <app-date-edit class="date-field" placeholder="Start date" #startDateFilter="ngModel"
                         [(ngModel)]="table.filters.startFilterDate"></app-date-edit>
          <app-date-edit class="date-field" placeholder="End date" #endDateFilter="ngModel"
                         [(ngModel)]="table.filters.endFilterDate"></app-date-edit>

          <mat-form-field>
            <input #minAmountField matInput (keydown.enter)="onSearch(searchButton.disabled)" placeholder="Min. Amount"
                   [(ngModel)]="table.filters.additionalValue1">
          </mat-form-field>
          <mat-form-field>
            <input #maxAmountField matInput (keydown.enter)="onSearch(searchButton.disabled)" placeholder="Max. Amount"
                   [(ngModel)]="table.filters.additionalValue2">
          </mat-form-field>

          <mat-form-field class="search-field">
            <input #searchField matInput (keydown.enter)="onSearch(searchButton.disabled)" placeholder="Search"
                   [(ngModel)]="table.filters.str">
          </mat-form-field>
          <button #searchButton mat-icon-button (click)="onSearch()"
                  [disabled]="startDateFilter.invalid || endDateFilter.invalid">
            <mat-icon>search</mat-icon>
          </button>
          <button mat-icon-button (click)="table.clearFilter()">
            <mat-icon>clear</mat-icon>
          </button>

        </div>
      </div>
    </div>

  </div>

  <app-mat-table-generator #table
    tableName="gpsloadsTable"
    [useEmbededFilter]="false"
    [columns]="columns"
    [dataSource]="dataSource"
    [editEnabled]="false"
    [deleteEnabled]="false"
    [customQueryParams]="{f: 'history'}"
    [viewEnabled]="true"
    [viewLink]="getViewLink"
    [multiselectEnabled]="false"

    >
  </app-mat-table-generator>
</mat-card>
